var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #97a89f;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 58,
    height: 58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 58,
    height: 58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58,29c-.65,38.67-57.35,38.66-58,0,.65-38.67,57.35-38.66,58,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.85,14.42c-.48,0-.98.06-1.5.16-3.41-4.42-11.01-4.42-14.41,0-9.57-2.05-14.22,12.34-5.44,16.54-.54,21.45-.62,14.15,22.08,15.42,1.78,0,3.23-1.47,3.23-3.28v-12.15c8.03-3.85,4.96-16.97-3.96-16.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.31,30.51c-.85.89-.48,4.36-.33,7.77h-23.99c.15-3.42.52-6.89-.33-7.77-7.92-4.52-3.95-14.99,3.92-15.39-.94,1.38-1.91,3.65-1.92,5.03,0,.8,1.06,1.07,1.44.37.84-1.51.75-4.03,2.25-5.34h0s0,0,0,0c.42-.52.89-.95,1.4-1.33.07-.06.16-.09.24-.15.4-.28.8-.53,1.24-.73.39-.18.79-.31,1.2-.43.13-.04.24-.09.37-.12.52-.13,1.04-.21,1.58-.24.02,0,.04,0,.06,0h0c2.67-.17,5.41.81,7.19,3.02,0,0,0,0,0,0,1.47,1.28,1.41,3.72,2.2,5.24.39.75,1.53.45,1.49-.4-.06-1.39-1-3.57-1.92-4.91,7.87.39,11.85,10.87,3.92,15.39M38.44,45.86h-18.9c-2.23.19-2.63-2.63-2.59-5.92h24.09c.04,3.29-.36,6.11-2.59,5.92M36.5,13.84c-3.86-4.38-11.14-4.38-14.99,0-10-1.67-14.81,13.06-5.92,17.86-.07,2-.02,4.51-.12,6.94-.29,6.94.77,8.65,3.21,8.77,2.22.1,17.55,0,19.76.02,6.41.18,3.33-12.12,4-15.75,8.87-4.8,4.04-19.51-5.94-17.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29,29c4.71,0,8.53-3.82,8.53-8.53s-3.82-8.53-8.53-8.53-8.53,3.82-8.53,8.53,3.82,8.53,8.53,8.53"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.c386d89ae7a0744d198fc7205bd3e042.svg";
export { ForwardRef as ReactComponent };